import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpa46rtxys: FaireProductEntity = {
  token: "p_cpa46rtxys",
  type: "product",
  name: "COLOR CONTRAST PATCHWORK SHORT LOOSE CARDIGAN",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/fba134897cd07e1e6b4de5e1156ea7227e747b12c25789bf36e9d5036b4a286b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba720198c914169ed3ffe6ca64769b42137279ff8ca9fd5ad59c7751a23e444a.jpeg",
    "https://cdn.faire.com/fastly/ca49590f1542db8e4574bc13396e2e2df77f201561834e449a92ccfec9010578.jpeg",
    "https://cdn.faire.com/fastly/c69d236de0fbc6ccc2d2141b22fb24889c5852076a5146dd473298a349bca572.jpeg",
    "https://cdn.faire.com/fastly/8ce3895aa5e2ebb1948f7bfa6233334863093a2adb1b4fb4ad6619d94271dc17.jpeg",
    "https://cdn.faire.com/fastly/a1061d02090e604f3adf4530b901427eb4bcfa0eb54f504ffecbcf6f6cd60d5e.jpeg",
    "https://cdn.faire.com/fastly/eeb4585f5d964e9833730e0d3f17ee39723cb5d4c19f7eae977b804713c73eb7.jpeg",
    "https://cdn.faire.com/fastly/5e6e8a1098c3be2fbaeb655e64a7264335969e1b05f0c1f67b4f7fcfaba7049d.jpeg",
    "https://cdn.faire.com/fastly/3b2d5f3f42684a3d417daefd8d98de69cb6583d5fdf403926d77b2aa3d345f88.jpeg",
    "https://cdn.faire.com/fastly/703386df35f37db62548d4a60aa051393996827023dba432bbd947499cb1393e.jpeg",
    "https://cdn.faire.com/fastly/ad35df9d6bafd5dfc8c3383bf97fcdd635f0282ab45a4ceb421ff7f1d2cd2d29.jpeg",
    "https://cdn.faire.com/fastly/e5ce1165a46147cc810fbdb4071d165205d04533985f3ea533295ea84778c642.jpeg",
    "https://cdn.faire.com/fastly/afad17b6fa68e29955401c0da0ec0c1529b7ee346f46b528c70aaef4fc2a40d5.jpeg",
  ],
  priceDollars: 16.53,
  description:
    "COLOR CONTRAST PATCHWORK SHORT LOOSE CARDIGAN\n100% POLYESTER\nSIZES : S,M,L,XL\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 33.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:34.803Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
